import { logErrorWithJsonData } from 'Rentlio/utils/logging'

const createLogger = (params, isBlockingError) => {
  return {
    logError: description => {
      logErrorWithJsonData(`RentlioPay error`, params, {
        critical: isBlockingError,
        schedulingPaymentsBlocked: isBlockingError,
        description: description
      })
    }
  }
}

export default createLogger
